/** @flow */
import type { DayOfWeek } from 'common/domain/DayOfWeek';
import type { TimeResolution } from './TimeResolution';
import type { DateRange, Interval } from '../../../domain/reach';
import { MetricsQuery } from './Metrics';

export type ListeningTimeState = {
  dateRange: DateRange;
  dateRangeCompared: ?DateRange;
  days: Array<DayOfWeek>;
  interval: Interval;

  listeningTimeByInterval: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };
  totalListeningTime: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };
  listeningTimePerPerson: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };

  timeResolution: TimeResolution;
}

export const parseListeningTimeState = (json: Object): ListeningTimeState => {
  const parseData = (dataObject: Object) => {
    return {
      isFetched: dataObject.isFetched,
      data: dataObject.data,
      error: dataObject.error,
    };
  };

  const query = MetricsQuery.fromJSON(json);
  const listeningTimeByInterval = parseData(json.listeningTimeByInterval);
  const totalListeningTime = parseData(json.totalListeningTime);
  const listeningTimePerPerson = parseData(json.listeningTimePerPerson);
  const timeResolution = json.timeResolution;

  return { ...query, listeningTimeByInterval, totalListeningTime, listeningTimePerPerson, timeResolution };
};

export type ReachState = {
  dateRange: DateRange;
  dateRangeCompared: ?DateRange;
  days: Array<DayOfWeek>;
  interval: Interval;

  interpolated?: boolean;

  reachByInterval: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };

  totalReach: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };
  averageQuarterHourReach: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };
  averageTotalReach: {
    isFetched: boolean;
    data: ?Object;
    error: ?Object;
  };
}

export const parseReachState = (json: Object): ReachState => {
  const parseData = (dataObject: Object) => {
    return {
      isFetched: dataObject.isFetched,
      data: dataObject.data,
      error: dataObject.error,
    };
  };

  const query = MetricsQuery.fromJSON(json);
  const reachByInterval = parseData(json.reachByInterval);
  const totalReach = parseData(json.totalReach);
  const averageQuarterHourReach = parseData(json.averageQuarterHourReach);
  const averageTotalReach = parseData(json.averageTotalReach);

  return { ...query, reachByInterval, totalReach, averageQuarterHourReach, averageTotalReach };
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/domain/State.js